import { Type } from './action-types';
import { stateFactory } from './factories';
import { VideoZipRequestAction, VideoZipRequestState } from './types';

const defaultState = stateFactory();

export default function reducer(
  state: VideoZipRequestState = defaultState,
  action: VideoZipRequestAction,
) {
  switch (action.type) {
    case Type.CREATE_VIDEO_ZIP_REQUEST: {
      return state.set('isCreatingZipRequest', true);
    }

    case Type.CREATE_VIDEO_ZIP_REQUEST_SUCCESS: {
      const { zipRequestId } = action.payload;

      return state
        .set('zipRequestId', zipRequestId)
        .set('isCreatingZipRequest', false);
    }

    case Type.CREATE_VIDEO_ZIP_REQUEST_FAILURE: {
      return state.set('isCreatingZipRequest', false);
    }

    case Type.GET_VIDEO_ZIP_REQUEST: {
      return state.set('isFetchingZipRequest', true);
    }

    case Type.GET_VIDEO_ZIP_REQUEST_SUCCESS: {
      const { zipRequestId } = action.payload;

      return state
        .set('zipRequestId', zipRequestId)
        .set('isFetchingZipRequest', false);
    }

    case Type.GET_VIDEO_ZIP_REQUEST_FAILURE: {
      return state.set('isFetchingZipRequest', false);
    }

    case Type.RESET_VIDEO_ZIP_REQUEST_STATE: {
      return state
        .set('zipRequestId', undefined)
        .set('isCreatingZipRequest', false)
        .set('isFetchingZipRequest', false);
    }

    default:
      return state;
  }
}
